import * as angular from "angular";
import {ProgressMenuItem} from "../../models/progress-menu/progress-menu-item.model";

const progressMenuItems: ProgressMenuItem[] = [
    {
        order: 1,
        title: "Match",
        subTitle: "Naviance and Clever schools",
        link: ""
    },
    {
        order: 2,
        title: "Verify",
        subTitle: "data matches by conducting a test import",
        link: "student-test-import"
    },
    {
        order: 3,
        title: "Import",
        subTitle: "the data",
        link: "student-import-records"
    }
];

export class ProgressMenuController {
    items: ProgressMenuItem[] = progressMenuItems;
    currentPage: number;
    isPageTwoReady: boolean;
    isPageThreeReady: boolean;

    /* @ngInject */
    constructor(
        public $route: angular.route.IRouteService,
        private $location:angular.ILocationService,
        private $routeParams: { districtId: string }
    ) {}

    isActiveItem(item: ProgressMenuItem): boolean {
        if (item.order <= this.currentPage) {
            return true;
        } else if (item.order === 2 && this.isPageTwoReady) {
            return true;
        }
        return item.order === 3 && this.isPageThreeReady;
    }

    isCurrentPageItem(item: ProgressMenuItem): boolean {
        return item.order === this.currentPage;
    }

    linkToPage(item: ProgressMenuItem) {
        if (!this.isActiveItem(item)) { return; }

        return this.$location.path(`${this.$routeParams.districtId}/${item.link}`);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/progress-menu/progress-menu.controller.ts